import {SolutionResponse} from '../solution/solution-support.types';
import {APIService} from '@/services/api.service';

export async function removePOI(
  activityId: string,
  problemId: string,
  sessionId: string,
  solutionId: string,
  isPoi: boolean,
): Promise<SolutionResponse> {
  return APIService.delete<SolutionResponse>(`activity`, {
    params: {
      session_id: sessionId,
      problem_id: problemId,
      solution_id: solutionId,
      [isPoi ? 'candidate_id' : 'activity_id']: activityId,
    },
  });
}
